
const tiposVeiculo = [
  { id: 'Toco', nome: 'Toco' },
  { id: 'VLC', nome: 'VLC' },
  { id: 'Tres_Quartos', nome: '3/4' },
  { id: 'Truck', nome: 'Truck' },
  { id: 'Bitruck', nome: 'Bitruck' },
  { id: 'Rodotrem', nome: 'Rodotrem' },
  { id: 'Bitrem', nome: 'Bitrem' },
  { id: 'Carreta_Ls', nome: 'Carreta LS' },
  { id: 'Carreta', nome: 'Carreta' }
]

export default tiposVeiculo



// WEBPACK FOOTER //
// ./src/vuex/cache/tiposVeiculo.js